/**
 * Version de l'application qui a écrit l'état stocké dans le navigateur (tokens, utilisateur, client_security…).
 *
 * La 1.5 a changé ce format : un utilisateur resté connecté depuis une version antérieure garde des jetons
 * que l'API refuse et reste bloqué. Au premier chargement, tout stockage qui ne porte pas ce marqueur est
 * vidé et l'utilisateur repasse par la connexion.
 *
 * À mettre à jour uniquement quand une version change à nouveau ce format, pas à chaque livraison.
 */
export const STORAGE_VERSION = '1.5';
export const STORAGE_VERSION_KEY = 'app_state_version';

/** Vide localStorage et sessionStorage s'ils n'ont pas été écrits par la version courante du format. */
export function purgeOutdatedStorage(): void {
  try {
    if (localStorage.getItem(STORAGE_VERSION_KEY) === STORAGE_VERSION) {
      return;
    }
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
  } catch {
    // Stockage inaccessible (navigation privée stricte, cookies bloqués) : rien à purger.
  }
}
